import React, { ReactElement } from 'react';
import { useModalsState, useCloseModal } from 'state/modal';
import { Modal } from 'common/modals/modal';

export const ModalsProvider = () => {
  const state = useModalsState();
  const { closeModal } = useCloseModal();

  return (
    <>
      {state.instances.map(modalInstance => {
        const { template, ...props } = modalInstance;

        return (
          <Modal
            {...props}
            key={modalInstance.id}
            show={modalInstance.id === state.active}
            onClose={() => closeModal(modalInstance.id as string)}>
            {() => React.cloneElement(template as ReactElement, props)}
          </Modal>
        );
      })}
    </>
  );
};
